import { useState } from "react"

import type { Editor } from "@tiptap/react"
import { BubbleMenuFormatButtons } from "@/screens/app/threads/components/center-content/bottom-bar/bubble-menu-format-buttons"

export function SnippetFormatToolbar({ editor }: { editor: Editor | null }) {
	const [isAddingLink, setIsAddingLink] = useState(false)
	const [linkUrl, setLinkUrl] = useState("")

	if (!editor) return null

	return (
		<div className="flex items-center text-secondary">
			{isAddingLink ? (
				<input
					type="url"
					value={linkUrl}
					onChange={(e) => setLinkUrl(e.target.value)}
					onKeyDown={(e) => {
						if (e.key === "Enter" && linkUrl) {
							editor
								.chain()
								.focus()
								.extendMarkRange("link")
								.setLink({ href: linkUrl, target: "_blank" })
								.run()
							setLinkUrl("")
							setIsAddingLink(false)
						}
						if (e.key === "Escape") {
							setLinkUrl("")
							setIsAddingLink(false)
						}
					}}
					placeholder="https://..."
					className="w-48 rounded border border-gray-200 bg-transparent px-2 py-1 text-sm outline-none dark:border-gray-700"
					autoFocus
				/>
			) : (
				<BubbleMenuFormatButtons
					editor={editor}
					onAddLink={() => setIsAddingLink(true)}
				/>
			)}
		</div>
	)
}
